/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'projects': {
    width: 21,
    height: 20,
    viewBox: '0 0 21 20',
    data: '<path pid="0" d="M5.038 18.637a3.127 3.127 0 1 0 0-6.254 3.127 3.127 0 0 0 0 6.254zm6-9.137h4.42c.597 0 1.08.484 1.08 1.08v.833a4.128 4.128 0 1 1-1 0v-.832a.08.08 0 0 0-.08-.081h-9.84a.08.08 0 0 0-.08.08v.833a4.128 4.128 0 1 1-1 0v-.832c0-.597.484-1.081 1.08-1.081h4.42v-.903a4.128 4.128 0 1 1 1 0V9.5zm5 9.137a3.127 3.127 0 1 0 0-6.254 3.127 3.127 0 0 0 0 6.254zm-5.5-11.01a3.127 3.127 0 1 0 0-6.254 3.127 3.127 0 0 0 0 6.254z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/projects.js